export default {
  list: {
    create: "Contact",
  },
  update: {
    delete: "Contact verwijderen",
  },
  create: {
    save: "Contact aanmaken",
    cancel: "Aanmaken annuleren",
    reset: "Nieuw contact leeg maken"
  }
}
